export var source = "query BuyQueueAvailableProducts($input: ProductsInput!) {\n  products(input: $input) {\n    id\n  }\n}";
export default source;